import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

export default class SiteHeader extends HTMLElement {
    constructor() {
        super();

        this.toggleNavLinks = this.querySelectorAll('.link-toggle-nav')
        this.nav = this.querySelector('nav.main-nav')
        this.navOpened = false;

        this.searchInput = this.parentElement.querySelector('input[type="search"]');

        this.currentScrollPosition = 0;
        this.previousScrollPosition = 0;
        this.isHeaderHidden = false;
        this.downThreshold = 200;
        this.upThreshold = 100;
        this.handleScrollState = this.handleScrollState.bind(this);
        this.dropdownMenus = this.querySelectorAll('.dropdown');
    }

    connectedCallback() {
        this.previousScrollPosition = window.scrollY || document.documentElement.scrollTop;
        window.addEventListener('scroll', this.handleScrollState);

        // Handle Navigation

        this.updateNavPosition()

        this.nav.addEventListener("click", (e) => {
            if (e.target === this.nav) {
                this.toggleNav()
            }
        })

        this.toggleNavLinks.forEach(toggleNavLink => {
            toggleNavLink.addEventListener('click', (e) => {
                e.preventDefault()
                this.updateNavPosition()
                this.toggleNav()
            })
        })

        const categoryLinks = this.nav.querySelectorAll('[data-target-panel]')
        categoryLinks.forEach(categoryLink => {
            categoryLink.addEventListener('click', e => {
                e.preventDefault()

                const activeLinks = categoryLink.closest('.nav-panel').querySelectorAll('.active')
                activeLinks.forEach(activeLink => {
                    activeLink.classList.remove('active')
                })
                categoryLink.classList.add('active')

                const lvl2Panels = this.nav.querySelectorAll('.nav-panel-lvl-2')
                lvl2Panels.forEach(lvl2Panel => {
                    lvl2Panel.classList.remove('opened')
                })

                const target = categoryLink.dataset.targetPanel
                const targetPanel = this.nav.querySelector(target)
                targetPanel.classList.add('opened')
                disableBodyScroll(targetPanel.querySelector('.nav-panel-body'))

            })
        })

        const closePanelLinks = this.nav.querySelectorAll('.link-close-panel')
        closePanelLinks.forEach(closePanelLink => {
            closePanelLink.addEventListener('click', e => {

                const lvl1activelink = this.nav.querySelector('.nav-panel-lvl-1 a.active')
                if (lvl1activelink) {
                    lvl1activelink.classList.remove('active')
                }

                const panel = closePanelLink.closest('.nav-panel')
                panel.classList.remove('opened')
            })
        })

        if (!this.isMobile()) {
            this.forceFirstLvl2Opened()
        }

        // Handle Search
        this.searchInput.addEventListener('search.opened', this.handleSearchOpen.bind(this));
        this.searchInput.addEventListener('search.closed', this.handleSearchClose);

        this.dropdownMenus.forEach((dropdownMenu) => {
            dropdownMenu.addEventListener('show.bs.dropdown', this.handleDropdownOpen.bind(this));
        });
    }

    /**
     * Callback d'événement appelé lorsque le menu déroulant est ouvert.
     * @param e
     */
    handleDropdownOpen(e) {
        // Si la navigation est ouverte, on la ferme
        if (this.navOpened) {
            this.toggleNav();
        }
    };

    disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScrollState);

        this.dropdownMenus.forEach((dropdownMenu) => {
            dropdownMenu.removeEventListener('show.bs.dropdown', this.handleDropdownOpen);
        });
    }

    toggleNav() {
        this.nav.classList.toggle('opened')

        this.navOpened = !this.navOpened;

        if (this.navOpened) {
            disableBodyScroll(this.nav.querySelector('.nav-panel-body'));
        } else {
            clearAllBodyScrollLocks();
        }

        this.classList.toggle('visible');

        const navIcons = this.querySelectorAll(".link-toggle-nav i")
        navIcons.forEach(navIcon => {
            if (this.navOpened) {
                navIcon.classList.remove('ri-menu-line')
                navIcon.classList.add('ri-close-large-line')
            } else {
                navIcon.classList.remove('ri-close-large-line')
                navIcon.classList.add('ri-menu-line')
            }
        })
    }

    forceFirstLvl2Opened() {
        const firstCategoryLink = this.nav.querySelector('[data-target-panel]')
        firstCategoryLink.classList.add('active')
        const firstLvl2Panel = this.nav.querySelector('.nav-panel-lvl-2')
        firstLvl2Panel.classList.add('opened')
    }

    isMobile() {
        return window.innerWidth < 992;
    }

    updateNavPosition() {
        this.style.setProperty('--panels-top-position', this.getBoundingClientRect().bottom + "px")
    }

    handleScrollState() {
        this.currentScrollPosition = window.scrollY || document.documentElement.scrollTop;
        const scrollDifference = this.currentScrollPosition - this.previousScrollPosition;

        if (scrollDifference > 0) {
            if (scrollDifference > this.downThreshold) {
                this.hideHeader();
                this.previousScrollPosition = this.currentScrollPosition;
            }
        } else if (scrollDifference < 0) {
            if (Math.abs(scrollDifference) > this.upThreshold) {
                this.showHeader();
                this.previousScrollPosition = this.currentScrollPosition;
            }
        }

        setTimeout(() => {
            this.updateNavPosition();
        }, 200)

    }

    hideHeader() {
        if (!this.isHeaderHidden) {
            this.classList.add('hidden');
            this.isHeaderHidden = true;
        }
    }

    showHeader() {
        if (this.isHeaderHidden) {
            this.classList.remove('hidden');
            this.isHeaderHidden = false;
        }
    }

    handleSearchOpen() {
        if (this.navOpened) {
            this.toggleNav()
        }

        disableBodyScroll(this.querySelector('.search-overlay'));
    }

    handleSearchClose() {
        clearAllBodyScrollLocks();
    }

}
